import React, { useEffect, useRef, useState } from "react";
import { TableProps } from "antd";
import {
  GetBusinessClientSortService,
  GetBusinessClientsService,
  GetClientOverviewService,
} from "../../../Services/BusinessClientsService/BusinessClientsService";
import Loader from "../../../Components/Loader/Loader";
import { useDispatch } from "react-redux";
import { setSelectedClient } from "../../../Reducer/SelectedClientReducer";
import { useNavigate } from "react-router-dom";
import "./BusinesClients.css";
import CommonTable, {
  TableRowAction,
} from "../../../Components/CustomTable/CustomTable";
import Pagination from "../../../Components/CustomPagination/Pagination/Pagination";
import Addclients from "../../../Components/Addclients/Addclients";
import SearchBar from "../../../Components/SeachBar/searchbar";
import ExportClientModal from "../../../Components/ExportPopup/ExportClientModal ";
// import Editclient from "../../../Components/Editclients/Editclient";

const BusinessClients = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dataSource, setDataSource] = useState<any[]>([]);
  const [shouldNavigate, setShouldNavigate] = useState(false);
  const [loading, setLoading] = useState(false);

  const [totalData, setTotalData] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const [selectedRows, setSelectedRows] = useState<any[]>([]);

  const [pageSize, setPageSize] = useState(10); // Number of records per page
  const [showPopup, setShowPopup] = useState(false);
  const [user, setuser] = useState("");
  const ref = useRef(null);
  //  Addclients modal
  const [isAddClientsOpen, setIsAddClientsOpen] = useState(false);
  const [editRow, setEditRow] = useState<any>(null);
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const [invoices, setInvoices] = useState<any[]>([]);
  const paginatedData = dataSource.slice(startIndex, endIndex);
  const [open, setOpen] = useState(false);
  const [pendingAction, setPendingAction] = useState<TableRowAction | null>(
    null,
  );
  const [selectAll, setSelectAll] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  // New state for search
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (shouldNavigate) {
      navigate("/overview");
      setShouldNavigate(false);
    }
  }, [shouldNavigate]);

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedRows([]);
      setSelectAll(false);
    } else {
      const allIds = dataSource.map((row) => row.id);
      setSelectedRows(allIds);
      setSelectAll(true);
    }
  };

  const columns = [
    {
      key: "selected",
      width: 50,
      title: (
        <input
          type="checkbox"
          checked={selectAll}
          onClick={(e) => e.stopPropagation()}
          onChange={handleSelectAll}
        />
      ),
      dataIndex: "",
      isCheckbox: true,
      showSortArrows: false,
      isSticky: true,
    },
    {
      key: "Name",
      width: 220,
      title: "Name",
      dataIndex: "name",
      showSortArrows: true,
      isSticky: true,
    },
    {
      key: "Email",
      width: 220,
      title: "Email",
      dataIndex: "email",
      showSortArrows: true,
      isSticky: true,
      isDash: true,
    },

    {
      key: "Items",
      title: "Costs",
      dataIndex: "items",
      showSortArrows: true,
    },
    {
      key: "Inbox",
      title: "Inbox",
      dataIndex: "inbox",
      showSortArrows: true,
    },
    {
      key: "Failed_Processing",
      title: "Failed Processing",
      dataIndex: "failedProcessed",
      showSortArrows: true,
      isRedIfPositive: true,
    },
    {
      key: "Pending",
      title: "Pending",
      dataIndex: "pending",
      showSortArrows: true,
    },
    {
      key: "To_Review",
      title: "To Review",
      dataIndex: "to_Review",
      showSortArrows: true,
    },
    {
      key: "Ready",
      title: "Ready",
      dataIndex: "ready",
      showSortArrows: true,
    },
    {
      key: "Exported",
      title: "Exported",
      dataIndex: "exported",
      showSortArrows: true,
    },
    {
      key: "Archived",
      title: "Archived",
      dataIndex: "archived",
      showSortArrows: true,
    },
    // {
    //   key: "Item_Delay",
    //   title: "Item Delay",
    //   dataIndex: "itemDelay",
    //   showSortArrows: true,
    //   isItemDelay: true,
    //   isDash: true,
    // },
    // {
    //   key: "Mobile_Users",
    //   title: "Mobile Users",
    //   dataIndex: "mobileUsers",
    //   showSortArrows: false,
    //   isDash: true,
    // },
    {
      key: "Latest_Item",
      title: "Latest Item",
      dataIndex: "latestItem",
      showSortArrows: true,
      isDate: true,
      isDash: true,
    },
    {
      key: "Oldest_Item",
      title: "Oldest Item",
      dataIndex: "oldestItem",
      showSortArrows: true,
      isOldestItem: true,
      isDash: true,
    },
    {
      key: "Status",
      title: "Status",
      dataIndex: "status",
      isStatus: true,
      useCircleStatus: true,
      showSortArrows: true,
    },
  ];
  useEffect(() => {
    FetchData();
  }, []);

  useEffect(() => {
    const userDataString = localStorage.getItem("user");
    if (userDataString) {
      try {
        const userData = JSON.parse(userDataString);
        console.log("User Data Object:", userData);
        setuser(userData.userId);
        console.log("User ID:", userData.userId);
      } catch (err) {
        console.error("Error parsing user data:", err);
      }
    }
  }, []);

  const FetchData = async (
    reverse: boolean = false,
    key: string = "default",
    search: string = searchTerm, // Use state value as default
  ) => {
    try {
      setLoading(true);
      const result = await GetBusinessClientSortService({
        sortBy: key,
        sortOrder: reverse ? "desc" : "asc",
        searchTerm: search, // Connected search to API
      });

      const withIds = result.map((item: any, index: number) => ({
        ...item,
        id: item.id ?? item.key ?? index,
      }));
      setDataSource(withIds);
      setTotalData(withIds.length);
    } catch (error) {
      setDataSource([]);
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page: number, pageSize?: number) => {
    setCurrentPage(page);
    if (pageSize) setPageSize(pageSize);
  };

  const HandleRecordClick = async (record: any) => {
    dispatch(setSelectedClient(record));

    if (record.userId) {
       
      const clientOverview = await GetClientOverviewService(record.clientId);
      navigate("/overview", { state: { clientOverview } });
      return;
    }

    navigate("/overview");
  };

  const handleCheckboxChange = (row: any, checked: boolean) => {
    setSelectedRows((prev) => {
      if (checked) {
        if (!prev.includes(row.id)) return [...prev, row.id];
        return prev;
      } else {
        return prev.filter((id) => id !== row.id);
      }
    });
  };

  console.log("selected rows :", selectedRows.length, dataSource.length);

  useEffect(() => {
    if (dataSource.length === 0) {
      setSelectAll(false);
      return;
    }

    setSelectAll(selectedRows.length === dataSource.length);
  }, [selectedRows, dataSource]);

  const handleClearSelection = () => {
    setSelectedRows([]);
    setSelectAll(false);
  };

  const selectedRowData = dataSource.filter((row) =>
    selectedRows.includes(row.id),
  );
  const isSingleSelection = selectedRows.length === 1;
  const hasExpiredSelected = selectedRowData.some((row) => row.status === 3);

  const requestTableAction = (action: TableRowAction) => {
    setPendingAction(action);
    setOpen(false);
  };

  useEffect(() => {
    if (selectedRows.length === 0) {
      setOpen(false);
    }
  }, [selectedRows.length]);

  const onChangeTableParams: TableProps<any>["onChange"] = (
    pagination,
    filters,
    sorter: any,
    extra,
  ) => {
    handlePageChange(pagination.current ?? 1, pagination.pageSize ?? 10);
  };

  const sortBusinessClients = async (reverse: boolean, key: string) => {
    try {
      setLoading(true);
      setSelectedRows([]);
      // The Key should be passed to the API to sort based on that key, For now we will use Name as thats the only one requested.
      await FetchData(reverse, key);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  // 1. New useEffect for "Live Search"
  useEffect(() => {
    // Create a timer to wait 500ms after the user stops typing
    const delayDebounceFn = setTimeout(() => {
      // Call your existing FetchData function
      FetchData(false, "default", searchTerm);
    }, 500);

    // Clean up the timer if the user types another letter before 500ms is up
    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]); // This triggers every time searchTerm changes

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="business-clients-container">
  
      <div
        style={{
          display: "flex",
          paddingBottom: "8px",
          justifyContent: "space-between",
        }}
      >
        <SearchBar
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm} // Every letter typed updates state
          onSearch={() => FetchData(false, "default", searchTerm)} // Button still works as a backup
        />

        <div style={{ display: "flex", alignItems: "center" }}>
          <div className="action-wrapper" ref={dropdownRef}>
            <button
              className="custom-btn"
              onClick={() => setOpen(!open)}
              disabled={selectedRows.length === 0}
            >
              Actions <span>{open ? "▲" : "▼"}</span>
            </button>

            {open && (
              <div className="dropdown-menu">
                <div className="dropdown-item">
                  <button
                    disabled={!isSingleSelection}
                    title={
                      isSingleSelection
                        ? "Edit selected client"
                        : "Select a single client to edit"
                    }
                    onClick={() => requestTableAction("edit")}
                  >
                    Edit
                  </button>
                </div>
                <div className="dropdown-item">
                  <button onClick={() => requestTableAction("delete")}>
                    Delete
                  </button>
                </div>
                {hasExpiredSelected && (
                  <div className="dropdown-item">
                    <button onClick={() => requestTableAction("resendEmail")}>
                      Resend Invite
                    </button>
                  </div>
                )}
                <div className="dropdown-item">
                  <button
                    onClick={() => {
                      setShowExportModal(true);
                      setOpen(false);
                    }}
                  >
                    Export to Excel
                  </button>
                </div>
              </div>
            )}
          </div>
          <button onClick={() => setShowPopup(true)} className="custom-btn">
            Create Clients
          </button>
        </div>

        <Addclients
          visible={showPopup}
          onClose={() => setShowPopup(false)}
          userid={user}
          fetchData={FetchData}
        />
      </div>
      <ExportClientModal
        open={showExportModal}
        onClose={() => setShowExportModal(false)}
        dataSource={dataSource}
        selectedRows={selectedRows}
      />
      {loading ? (
        <Loader />
      ) : dataSource.length === 0 ? (
        <h1 className="no-data-found">No data found</h1>
      ) : (
        <>
          <CommonTable
            sortInvoices={sortBusinessClients}
            columns={columns}
            data={dataSource}
            onRowClick={HandleRecordClick}
            onRowCheckboxChange={handleCheckboxChange}
            selectedRowKeys={selectedRows}
            handleClearSelection={handleClearSelection}
            rowKey="id"
            fetchData={FetchData}
            pendingAction={pendingAction}
            onPendingActionHandled={() => setPendingAction(null)}
          />

          {isAddClientsOpen && (
            <Addclients
              visible={isAddClientsOpen}
              onClose={() => {
                setIsAddClientsOpen(false);
                setEditRow(null);
              }}
              rowData={editRow}
            />
          )}
        </>
      )}
    </div>
  );
};

export default BusinessClients;
